import React, { FC } from 'react'
import { Tabs } from 'antd'
import { TFunction } from 'i18next'
import { WithTranslation } from 'react-i18next'
import { FormSubmitHandler } from 'redux-form'

// components
import { useDispatch } from 'react-redux'
import ItemProperties from './ItemProperties'

// reducers
import { LOAD } from '../../../reducers/form/formTypes'

// types
import { IFormItemData } from '../../../types/interfaces'

// enums
import { FORM_ATTRIBUTES, ITEM_PROPERTIES_RIGHT_SIDEBAR_TAB_KEYS, PAGE } from '../../../utils/enums'

// helpers
import { getApiEndpointPath } from '../../../utils/helper'

// utils
import { patchReq } from '../../../utils/request'

// forms
import ElementCSSForm from '../../../components/forms/ElementCSSForm'
import DocumentForm from '../../../components/forms/DocumentForm'

const { TabPane } = Tabs

export type ComponentProps = {
	onRemoveItem: Function
}

type Props = {
	t: TFunction
	selectedItemType: string
	handleElementFormSubmit: FormSubmitHandler<IFormItemData, ComponentProps, string>
	handleCSSFormSubmit: FormSubmitHandler<IFormItemData, WithTranslation, string>
	tabKey: string
	onTabClicked: any
	onRemoveItem: Function
	formId?: string
	page: PAGE
	priorities: string[]
}

const ItemPropertiesRightSideBar: FC<Props> = (props) => {
	const { t, selectedItemType, handleElementFormSubmit, tabKey, onTabClicked, handleCSSFormSubmit, onRemoveItem, formId, page, priorities } = props
	const dispatch = useDispatch()

	// update document attributes for form
	const handleDocumentFormSubmit = async (data: any) => {
		dispatch({ type: LOAD, load: true })
		try {
			await patchReq(getApiEndpointPath(page, formId, null, true), undefined, {
				formDocument: {
					[FORM_ATTRIBUTES.BACKGROUND]: data?.[FORM_ATTRIBUTES.BACKGROUND]
				}
			})
		} catch (err: any) {
			/* eslint-disable-next-line no-console */
			console.error(err.message)
		} finally {
			dispatch({ type: LOAD, load: false })
		}
	}

	return (
		<Tabs onTabClick={onTabClicked} className={'item-properties-tab'} activeKey={tabKey}>
			<TabPane tab={t('loc:General')} key={ITEM_PROPERTIES_RIGHT_SIDEBAR_TAB_KEYS.TAB1} disabled={selectedItemType === ''}>
				<ItemProperties
					t={t}
					priorities={priorities}
					selectedItemType={selectedItemType}
					handleElementFormSubmit={handleElementFormSubmit}
					onRemoveItem={onRemoveItem}
				/>
			</TabPane>
			<TabPane tab={t('loc:CSS')} key={ITEM_PROPERTIES_RIGHT_SIDEBAR_TAB_KEYS.TAB2} disabled={selectedItemType === ''}>
				<ElementCSSForm elementType={selectedItemType} onSubmit={handleCSSFormSubmit} />
			</TabPane>
			<TabPane tab={t('loc:Document')} key={ITEM_PROPERTIES_RIGHT_SIDEBAR_TAB_KEYS.TAB3}>
				<DocumentForm onSubmit={handleDocumentFormSubmit} />
			</TabPane>
		</Tabs>
	)
}

export default React.memo(ItemPropertiesRightSideBar)
